// extracted by mini-css-extract-plugin
module.exports = {"column":"DateRangePicker_column__k4G_y","header":"DateRangePicker_header__XlSye"};